import * as CryptoJS from 'crypto-js'
import format from 'date-fns/format'

export function encryptPassword (plainPassword) {
  var salt = CryptoJS.lib.WordArray.random(16)

  var key = CryptoJS.PBKDF2(plainPassword, salt, {
      keySize: 256 / 32,
      iterations: 100,
    })

  var iv = CryptoJS.lib.WordArray.random(128 / 8)
  var datePipeString = format(new Date(), 'yyyy-MM-dd-HH:mm:ss')

  var encrypted = CryptoJS.AES.encrypt(datePipeString, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  })

  var s1 = salt.toString(CryptoJS.enc.Base64)
  var s2 = iv.toString(CryptoJS.enc.Base64)
  var s3 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)

  return s1 + 'x3Y' + s2 + '0z=' + s3
  }
